var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Check, Close, Download, Visibility } from '@mui/icons-material';
import { useCacheStore } from '../../../../stores/CacheStore';
import { FilePreviewAvatar } from './FilePreviewAvatar';
import { FileView } from '../../../../components/FileView';
import { AuthConstants } from '../../../../util/auth-constants';
import { FileUtil } from '../../../utils/FileUtil';
import { TituloCardCinza } from '../../View/TituloCardCinza';
import { ShowContent } from '../../../../components/ShowContent';
import { ParecerEnum } from '../../../../model/enums/ParecerEnum';
import { AnexoApi } from '../../../../apis/anexo-api';
export var ConfirmacaoAnexos = function (_a) {
    //region Constants
    var _b, _c, _d;
    var sessao = _a.sessao, indexViewed = _a.indexViewed, setIndexViewed = _a.setIndexViewed, setActiveStep = _a.setActiveStep;
    var _e = useState(undefined), itemView = _e[0], setItemView = _e[1];
    var _f = useState(undefined), indexView = _f[0], setIndexView = _f[1];
    var _g = useState(null), fileItem = _g[0], setFileItem = _g[1];
    var _h = useState(undefined), mimeType = _h[0], setMimeType = _h[1];
    var _j = useState(undefined), fileUrl = _j[0], setFileUrl = _j[1];
    var _k = useState(false), openViewModal = _k[0], setOpenViewModal = _k[1];
    //endregion
    //region Hooks
    useEffect(function () {
        var anexosCache = useCacheStore.getState().getCache(AuthConstants.INDEX_ANEXOS_VIEWED);
        if (anexosCache && Object.values(anexosCache).length > 0) {
            setIndexViewed(Object.values(anexosCache).map(Number));
        }
    }, []);
    useEffect(function () {
        useCacheStore.getState().setCache(AuthConstants.INDEX_ANEXOS_VIEWED, __assign({}, indexViewed));
    }, [indexViewed, fileItem]);
    var preview = useCallback(function (base64) {
        var _a, _b, _c, _d;
        var result = base64 ? FileUtil.parseFileBase64(base64) : null;
        return (_jsx(FilePreviewAvatar, { fileName: (_a = result === null || result === void 0 ? void 0 : result.fileName) !== null && _a !== void 0 ? _a : 'Arquivo não encontrado', mimeType: (_b = result === null || result === void 0 ? void 0 : result.mimeType) !== null && _b !== void 0 ? _b : '', fileUrl: (_c = result === null || result === void 0 ? void 0 : result.fileUrl) !== null && _c !== void 0 ? _c : '', data: (_d = result === null || result === void 0 ? void 0 : result.data) !== null && _d !== void 0 ? _d : '' }));
    }, []);
    //region Arquivos
    var base64ToFile = useCallback(function (base64) {
        return FileUtil.base64ToFile(base64);
    }, []);
    var itens = useCallback(function () {
        var _a;
        return (_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) !== null && _a !== void 0 ? _a : [];
    }, [sessao === null || sessao === void 0 ? void 0 : sessao.itens]);
    var item = useCallback(function (index) {
        var _a;
        if (!index) {
            return undefined;
        }
        if ((itens === null || itens === void 0 ? void 0 : itens.length) < index) {
            return undefined;
        }
        return (_a = itens()[index]) !== null && _a !== void 0 ? _a : undefined;
    }, [itens]);
    var files = useCallback(function (idItem) {
        var _a, _b;
        if (!idItem) {
            return [];
        }
        var _item = item(idItem);
        return (_b = (_a = _item === null || _item === void 0 ? void 0 : _item.anexos) === null || _a === void 0 ? void 0 : _a.map(function (reqAnexo) {
            var _a;
            if (reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64)
                return base64ToFile(reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64);
            if ((_a = reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.anexo) === null || _a === void 0 ? void 0 : _a.nomeArquivo)
                return new File([new Blob()], reqAnexo.anexo.nomeArquivo, { type: reqAnexo.anexo.extensao || '' });
            return null;
        }).filter(function (it) { return !!it; })) !== null && _b !== void 0 ? _b : [];
    }, [base64ToFile, item]);
    var filesBase64 = useCallback(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = itens()) === null || _a === void 0 ? void 0 : _a.flatMap(function (it) { var _a; return ((_a = it.anexos) !== null && _a !== void 0 ? _a : []); })) === null || _b === void 0 ? void 0 : _b.map(function (reqAnexo) { var _a; return ((_a = reqAnexo === null || reqAnexo === void 0 ? void 0 : reqAnexo.arquivoBase64) !== null && _a !== void 0 ? _a : ''); })) !== null && _c !== void 0 ? _c : [];
    }, [itens]);
    var fileBase64 = useCallback(function (index) {
        var _a, _b;
        if (index === undefined) {
            return undefined;
        }
        if (((_a = filesBase64()) === null || _a === void 0 ? void 0 : _a.length) < index) {
            return undefined;
        }
        return (_b = filesBase64()[index]) !== null && _b !== void 0 ? _b : undefined;
    }, [filesBase64]);
    var anexos = useCallback(function () {
        var _a, _b;
        return (_b = (_a = itens()) === null || _a === void 0 ? void 0 : _a.flatMap(function (it) { var _a; return ((_a = it.anexos) !== null && _a !== void 0 ? _a : []); }).filter(function (it) { return !!it; })) !== null && _b !== void 0 ? _b : [];
    }, [itens]);
    var anexo = useCallback(function (indexAnexo) {
        var _a, _b;
        if (indexAnexo === undefined) {
            return undefined;
        }
        if (((_a = anexos()) === null || _a === void 0 ? void 0 : _a.length) < indexAnexo) {
            return undefined;
        }
        return (_b = anexos()[indexAnexo]) !== null && _b !== void 0 ? _b : undefined;
    }, [anexos]);
    //endregion
    //endregion
    //region Handles
    var handleGetItem = function (anexo) {
        var _a;
        if (!anexo) {
            return undefined;
        }
        return (_a = itens()) === null || _a === void 0 ? void 0 : _a.find(function (it) {
            var _a;
            return ((_a = it === null || it === void 0 ? void 0 : it.anexos) === null || _a === void 0 ? void 0 : _a.find(function (a) { return (a === null || a === void 0 ? void 0 : a.id) === (anexo === null || anexo === void 0 ? void 0 : anexo.id); })) !== undefined;
        });
    };
    var handleDownload = function (item) { return __awaiter(void 0, void 0, Promise, function () {
        var blob, url, a, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (item === null || item === void 0 ? void 0 : item.arquivoBase64) {
                        FileUtil.downloadBase64File(item.arquivoBase64);
                        return [2 /*return*/];
                    }
                    if (!((_a = item === null || item === void 0 ? void 0 : item.anexo) === null || _a === void 0 ? void 0 : _a.hashArquivo)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, AnexoApi.downloadAnexo(item.anexo.hashArquivo)];
                case 2:
                    blob = _b.sent();
                    url = URL.createObjectURL(blob);
                    a = document.createElement('a');
                    a.href = url;
                    a.download = item.anexo.nomeArquivo || 'anexo';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    console.error('Erro ao baixar anexo', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleVisualizar = function (item, index, openModal) {
        if (openModal === void 0) { openModal = true; }
        return __awaiter(void 0, void 0, Promise, function () {
            var mimeAndBase64, mimeType, parts, typeMatch, blob, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        handleItem(item);
                        mimeAndBase64 = '';
                        mimeType = null;
                        if (!(item === null || item === void 0 ? void 0 : item.arquivoBase64)) return [3 /*break*/, 1];
                        parts = item.arquivoBase64.split(',');
                        if ((parts === null || parts === void 0 ? void 0 : parts.length) < 3) {
                            console.error('Base64 mal formatado');
                            return [2 /*return*/];
                        }
                        mimeAndBase64 = parts[1] + ',' + parts[2];
                        typeMatch = /data:(.*);base64/.exec(mimeAndBase64);
                        mimeType = typeMatch ? typeMatch[1] : null;
                        return [3 /*break*/, 7];
                    case 1:
                        if (!((_a = item === null || item === void 0 ? void 0 : item.anexo) === null || _a === void 0 ? void 0 : _a.hashArquivo)) return [3 /*break*/, 6];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, AnexoApi.downloadAnexo(item.anexo.hashArquivo)];
                    case 3:
                        blob = _b.sent();
                        mimeAndBase64 = URL.createObjectURL(blob);
                        mimeType = blob.type || item.anexo.extensao || 'application/pdf';
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _b.sent();
                        console.error('Erro ao baixar anexo para visualização', err_2);
                        return [2 /*return*/];
                    case 5: return [3 /*break*/, 7];
                    case 6: return [2 /*return*/];
                    case 7:
                        if (!mimeType) {
                            console.error('Tipo MIME não pôde ser extraído.');
                            return [2 /*return*/];
                        }
                        setFileUrl(mimeAndBase64);
                        setMimeType(mimeType);
                        setIndexView(index);
                        setFileItem(item);
                        setIndexViewed(function (prev) { return ((prev !== null && prev !== void 0 ? prev : []).includes(item.id) ? (prev !== null && prev !== void 0 ? prev : []) : __spreadArray(__spreadArray([], prev, true), [item.id], false)); });
                        if (openModal) {
                            setOpenViewModal(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleOnClose = function () {
        setOpenViewModal(false);
        setIndexView(undefined);
        setMimeType(undefined);
        setFileUrl(undefined);
        setFileItem(null);
    };
    var handlePrevView = function () {
        var prevViewIndex = (indexView !== null && indexView !== void 0 ? indexView : 1) - 1;
        var prevItem = anexo(prevViewIndex);
        var prevBase64 = fileBase64(prevViewIndex);
        if (!prevItem) {
            console.error('Não há arquivos anteriores a esse.');
        }
        handleVisualizar(prevItem, prevViewIndex, false);
    };
    var handleNextView = function () {
        var nextIndex = (indexView !== null && indexView !== void 0 ? indexView : 0) + 1;
        var nextItem = anexo(nextIndex);
        var nextBase64 = fileBase64(nextIndex);
        if (!nextItem) {
            console.error('Não há arquivos posteriores a esse.');
        }
        handleVisualizar(nextItem, nextIndex, false);
    };
    var handleItem = function (anexo) {
        var item = handleGetItem(anexo);
        setItemView(item);
    };
    var viewedIcon = useCallback(function () {
        return (_jsx(Box, __assign({ sx: {
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: 'green',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } }, { children: _jsx(Check, { sx: { color: 'white', fontSize: 16 } }) })));
    }, []);
    var noViewedIcon = useCallback(function () {
        return (_jsx(Tooltip, __assign({ title: 'Arquivo não possui visualização' }, { children: _jsx(Box, __assign({ sx: {
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    backgroundColor: '#fbc21a',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } }, { children: _jsx(Check, { sx: { color: 'white', fontSize: 16 } }) })) })));
    }, []);
    var notViewedIcon = useCallback(function () {
        return (_jsx(Box, __assign({ sx: {
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: 'red',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } }, { children: _jsx(Close, { sx: { color: 'white', fontSize: 16 } }) })));
    }, []);
    var maxIndex = useMemo(function () {
        var _a, _b;
        return (((_b = ((_a = filesBase64()) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) - 1);
    }, [filesBase64]);
    var icon = useCallback(function (it) {
        var _a;
        var extensao = (_a = it === null || it === void 0 ? void 0 : it.anexo) === null || _a === void 0 ? void 0 : _a.extensao;
        var isNotView = extensao === 'application/zip' || extensao === 'application/x-zip-compressed';
        var viewIcon = (isNotView ? noViewedIcon() : notViewedIcon());
        return (indexViewed !== null && indexViewed !== void 0 ? indexViewed : []).includes(it === null || it === void 0 ? void 0 : it.id) ? viewedIcon() : viewIcon;
    }, [indexViewed, noViewedIcon, viewedIcon, notViewedIcon]);
    var hasAnyAnexo = useMemo(function () {
        var _a;
        return ((_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) !== null && _a !== void 0 ? _a : []).some(function (sessaoItem) { var _a; return ((_a = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) !== null && _a !== void 0 ? _a : []).length > 0; });
    }, [sessao]);
    if (!hasAnyAnexo) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(TituloCardCinza, __assign({ titulo: (_b = sessao === null || sessao === void 0 ? void 0 : sessao.nome) !== null && _b !== void 0 ? _b : '', onClick: function () {
                    setActiveStep === null || setActiveStep === void 0 ? void 0 : setActiveStep(2);
                } }, { children: _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: (_c = sessao === null || sessao === void 0 ? void 0 : sessao.itens) === null || _c === void 0 ? void 0 : _c.map(function (sessaoItem, index) {
                        var _a, _b, _c, _d;
                        return (_jsx(ShowContent, __assign({ show: ((_b = ((_a = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0 }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Box, __assign({ sx: {
                                        border: '1px solid #ccc',
                                        borderRadius: 2,
                                        padding: { xs: 2, md: 3 },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        overflow: 'hidden'
                                    } }, { children: _jsx(ShowContent, __assign({ show: ((_c = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) !== null && _c !== void 0 ? _c : []).length > 0 }, { children: _jsx(Box, __assign({ sx: { width: '100%' } }, { children: (_d = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) === null || _d === void 0 ? void 0 : _d.map(function (it, anexoIndex) {
                                                var _a, _b, _c, _d, _e, _f, _g;
                                                return (_jsx(Box, __assign({ sx: {
                                                        width: '100%',
                                                        marginBottom: anexoIndex < ((_b = (_a = sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.anexos) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - 1 ? 2 : 0
                                                    } }, { children: _jsxs(Box, __assign({ sx: {
                                                            display: 'flex',
                                                            flexDirection: { xs: 'column', md: 'row' },
                                                            alignItems: { xs: 'flex-start', md: 'center' },
                                                            gap: { xs: 2, md: 1 },
                                                            width: '100%',
                                                            minWidth: 0,
                                                            overflow: 'hidden'
                                                        } }, { children: [_jsxs(Box, __assign({ sx: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    flex: 1,
                                                                    minWidth: 0,
                                                                    overflow: 'hidden'
                                                                } }, { children: [_jsx(Box, __assign({ sx: { flexShrink: 0 } }, { children: icon(it) })), _jsx(Box, __assign({ sx: { flexShrink: 0 } }, { children: preview(it === null || it === void 0 ? void 0 : it.arquivoBase64) })), _jsxs(Box, __assign({ sx: {
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            textAlign: 'left',
                                                                            minWidth: 0,
                                                                            overflow: 'hidden',
                                                                            flex: 1
                                                                        } }, { children: [_jsx(Typography, __assign({ variant: "caption", color: "text.secondary", sx: {
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                } }, { children: (_d = (_c = it === null || it === void 0 ? void 0 : it.anexo) === null || _c === void 0 ? void 0 : _c.nomeArquivo) !== null && _d !== void 0 ? _d : 'Não Informado' })), _jsxs(Typography, __assign({ variant: "caption", color: "text.secondary", sx: {
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                } }, { children: [(_f = (_e = it === null || it === void 0 ? void 0 : it.anexo) === null || _e === void 0 ? void 0 : _e.tamanhoArquivo) !== null && _f !== void 0 ? _f : '0', " Kb |", ' ', ParecerEnum.getDescricao((_g = it === null || it === void 0 ? void 0 : it.parecer) !== null && _g !== void 0 ? _g : ParecerEnum.AGUARDANDO_ANALISE)] }))] }))] })), _jsxs(Box, __assign({ sx: {
                                                                    display: 'flex',
                                                                    gap: 1,
                                                                    flexWrap: 'wrap',
                                                                    justifyContent: { xs: 'center', md: 'flex-end' },
                                                                    alignSelf: { xs: 'stretch', md: 'auto' },
                                                                    width: { xs: '100%', md: 'auto' },
                                                                    minWidth: 0
                                                                } }, { children: [_jsx(Button, __assign({ onClick: function () { handleDownload(it); }, startIcon: _jsx(Download, {}), variant: "outlined", color: "primary", disabled: !it, size: "small", sx: {
                                                                            minWidth: { xs: 'auto', md: '100px' },
                                                                            fontSize: { xs: '0.7rem', md: '0.875rem' },
                                                                            padding: { xs: '4px 8px', md: '6px 16px' }
                                                                        } }, { children: "Baixar" })), _jsx(Button, __assign({ onClick: function () {
                                                                            handleVisualizar(it, index);
                                                                        }, startIcon: _jsx(Visibility, {}), sx: {
                                                                            minWidth: { xs: 'auto', md: '120px' },
                                                                            fontSize: { xs: '0.7rem', md: '0.875rem' },
                                                                            padding: { xs: '4px 8px', md: '6px 16px' }
                                                                        }, variant: "contained", color: "primary", disabled: !it, size: "small" }, { children: "Visualizar" }))] }))] })) }), "".concat(anexoIndex === null || anexoIndex === void 0 ? void 0 : anexoIndex.toString())));
                                            }) })) })) })) }), sessaoItem === null || sessaoItem === void 0 ? void 0 : sessaoItem.id) }), "show-".concat(index === null || index === void 0 ? void 0 : index.toString())));
                    }) })) })), _jsx(FileView, { handleNextView: handleNextView, handlePrevView: handlePrevView, fileProps: {
                    name: ((_d = files()[(indexView !== null && indexView !== void 0 ? indexView : 0)]) === null || _d === void 0 ? void 0 : _d.name) || 'Visualização de Arquivo',
                    type: mimeType,
                    url: fileUrl,
                }, handleOnClose: handleOnClose, indexView: indexView, open: openViewModal, maxIndex: maxIndex, item: itemView })] }));
};
